package com.tixforgigs.common.core.enums

enum class MandarinInputType {
  ACADEMIC_TITLE,
  FIRST_NAME,
  LAST_NAME,
  DISPLAY_NAME,
  EMAIL,
  PASSWORD,
  BIRTHDATE,
  BANK_NAME,
  BANK_ACCOUNT_OWNER,
  BANK_ACCOUNT_IBAN,
  BANK_ACCOUNT_BIC,
  PREPAYMENT_PAYEE_NAME,
  PREPAYMENT_PAYEE_IBAN,
  PREPAYMENT_AMOUNT,
  PREPAYMENT_REASON,
  COMPANY_NAME,
  STREET,
  HOUSE_NUMBER,
  ADDRESS_ADDITION,
  POSTAL_CODE,
  CITY,
  RESALE_START,
  RESALE_END,
  VOUCHER,
  GENERIC
}

enum class MandarinSelectType {
  GENDER,
  PAYMENT_COUNTRY
}

enum class MandarinCheckboxType {
  PRIVATE_RESALE,
  TEMPLATE_CONFIG_SEARCH_ENABLED,
  TEMPLATE_CONFIG_DETAIL_DESCRIPTION_ENABLED
}